import React from "react";
import styled from "styled-components";
import { RouteComponentProps } from "react-router-dom";

// @ts-ignore
import { CWBTableRow } from "cwb-react";
import ContentLoader from "react-content-loader";

interface IProps extends RouteComponentProps<any> {
  row: any;
  rowProps: any;
}

const RowLoadingPlaceholder = ({ row, rowProps }: IProps) => (
  <>
    <StyledRow>
      {row &&
        Object.keys(row).length &&
        Object.keys(row).map((x, idx) => (
          <td key={idx}>
            <ContentLoader
              speed={2}
              width={2000}
              height={35}
              viewBox="0 0 2000 35"
              backgroundColor="#f3f3f3" // blue/grey-ish: #bfd1e8
              foregroundColor="#ecebeb"
              style={{ width: "100%" }}
            >
              <rect x="50" y="5" rx="5" ry="5" width="1900" height="25" />
            </ContentLoader>
          </td>
        ))}
    </StyledRow>
  </>
);

export default RowLoadingPlaceholder;

const StyledRow = styled(CWBTableRow)`
  height: 64px;
  border: 0;
  box-shadow: inset 0 -1px 0 0 #e7e7f0;

  &.deleted * {
    text-decoration: line-through;
  }

  td {
    border: 0;
    color: ${(p) => p.theme.grey};
    font-size: ${(p) => p.theme["font-size"]};
  }

  i {
    cursor: pointer;
    color: ${(p) => p.theme.grey};
    &.blue {
      color: ${(p) => p.theme.lightBlue};
    }
    &.grey {
      color: ${(p) => p.theme.kiosk.bdColor};
    }
    &.pink {
      color: ${(p) => p.theme.kiosk.pink};
    }
    &.disabled {
      color: ${(p) => p.theme["disabled-grey"]};
      cursor: default;
    }
  }
`;
